/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ConfigurazioneMailForm } from './configurazione-mail-form';
import { ConfigurazioneSmsForm } from './configurazione-sms-form';
import { PagoPaConfigForm } from './pago-pa-config-form';
import { TipologiaComune } from './tipologia-comune';


export interface ComuneAdminCreationForm { 
    nome: string;
    slug: string;
    prefisso_comune?: string;
    codice_fiscale?: string;
    email?: string;
    url_logo_comune?: string;
    url_comune?: string;
    tipologia?: TipologiaComune;
    enabled?: boolean;
    comune_nascosto?: boolean;
    configurazione_mail?: ConfigurazioneMailForm;
    configurazione_sms?: ConfigurazioneSmsForm;
    pago_pa_config?: PagoPaConfigForm;
    referente_email?: string;
}



